/**
 * «Показать ещё» у «Недавно добавленных» (ТЗ главной § 22.7): догружать страницы, пока в кэше не наберётся
 * `need` записей или страницы не кончатся. Догрузка может пропасть без ошибки: перечитка всего кэша после «Связь
 * восстановлена» (`invalidateQueries` в `NetworkSync`) отменяет идущую `fetchNextPage` и перечитывает только уже
 * загруженные страницы — после «Повторить» в окне было 10 записей вместо 15 (приёмка главной D, A2-11). Тогда
 * догружаем ещё раз, но не больше `attempts` раз. Чистая функция без alias-импортов — её собирают тесты.
 */

export interface PageStep {
  /** Сколько записей в кэше после шага. */
  loaded: number;
  /** Сервер отдаст ещё страницу. */
  hasNext: boolean;
  /** Шаг закончился ошибкой — на месте кнопки «Не загрузилось.» и «Повторить». */
  error: boolean;
}

export async function loadUntil(
  need: number,
  current: PageStep,
  fetchNext: () => Promise<PageStep>,
  attempts = 3,
): Promise<{ loaded: number; error: boolean }> {
  let step = current;
  for (let attempt = 0; attempt < attempts && step.loaded < need && step.hasNext; attempt += 1) {
    step = await fetchNext();
    if (step.error) return { loaded: step.loaded, error: true };
  }
  return { loaded: step.loaded, error: false };
}
